<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel"
           :class-name="z100000">
      <h3 slot="header" class="modal-header">结算单驳回</h3>

      <div style="display: flex;">
        <span style="width: 40px;flex: none;">原因</span>
        <Input type="textarea" :rows="3" v-model="remark" />
      </div>
    </Modal>
  </div>


</template>
<script>
  // import {rejectBalance} from "../../../api/settleManage";
  import {auditRejectBalance,ownerRejectBalance} from "../../../api/settleManage";

  export default {
    name: "",
    components: {},
    props: {
      balanceFid: {
        type: String,
        default: ''
      },
      n: {
        type: Number,
        default: 0
      },
      balanceStatus: {
        type: Number,
        default: 0
      },
    },
    watch: {
      n() {
        this.remark=''
        this.isShow = true
      }
    },
    data() {
      return {
        z100000: 'z100000',
        remark: '',
        loading: true,
        isShow: false,
      }
    },
    methods: {
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if (!this.remark) {
          this.$Message.info('请填写原因')
          this.changeLoading()
          return

        }
        let params = {
          balanceFid: this.balanceFid,
          remark: this.remark

        }

        if(this.balanceStatus===0){
          ownerRejectBalance(params).then(res => {

          }).catch(error => {

          }).finally(() => {
            this.$emit('done')
            this.isShow=false
          })
        }
        if(this.balanceStatus===1){
          auditRejectBalance(params).then(res => {
          }).catch(error => {

          }).finally(() => {
            this.$emit('done')
            this.isShow=false
          })
        }


        // this.dataList.splice(index, 1)


      },
      cancel() {

      }
    }

  }
</script>

<style scoped>

</style>
